import { useState, useEffect } from 'react';

const BREAKPOINTS = [
  { max: 640, dateCol: 140, firstCol: 72 },
  { max: 1024, dateCol: 180, firstCol: 90 },
  { max: 1280, dateCol: 220, firstCol: 110 },
  { max: Infinity, dateCol: 280, firstCol: 120 },
];

function getWidths(width) {
  for (const bp of BREAKPOINTS) {
    if (width < bp.max) {
      return { dateColWidth: bp.dateCol, firstColWidth: bp.firstCol };
    }
  }
  return { dateColWidth: 280, firstColWidth: 120 };
}

export function useBoardColumnWidth() {
  const [widths, setWidths] = useState(() => getWidths(window.innerWidth));

  useEffect(() => {
    const handleResize = () => {
      setWidths(getWidths(window.innerWidth));
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return widths;
}
